import { useMemo } from "react";
import { TEMPLATES } from "../../../../templates/loader";
import { usePageBuilder } from "../../hooks";
import { useProjectNameEditing } from "./useProjectNameEditing";
import { useJsonExport } from "./useJsonExport";
import { usePublishModal } from "./usePublishModal";
import { useHtmlPreview } from "./useHTMLPreview";
import { useProject } from "../../../project/context/ProjectContext";

export function usePageBuilderTopBar() {
  const { editorRef, isReady } = usePageBuilder();
  const { activeTemplateId, setActiveTemplateId, projectName, setProjectName, slugName, handleChangeSlug } =
    useProject();

  const templates = useMemo(() => TEMPLATES, []);

  const nameEditing = useProjectNameEditing(projectName, setProjectName);
  const html = useHtmlPreview(editorRef, projectName);
  const saveJSON = useJsonExport(editorRef, projectName, activeTemplateId);
  const publish = usePublishModal();

  return {
    // core
    isReady,
    editorRef,
    templates,

    // project data
    projectName,
    activeTemplateId,
    setActiveTemplateId,
    slugName,
    handleChangeSlug,

    // grouped features
    nameEditing,
    html,
    saveJSON,
    publish,
  };
}
